import { __rest, __assign } from '../node_modules/tslib/tslib.es6.esm.js';
import * as React from 'react';
import classNames from 'classnames';

var NV_HEADLINE_ELEMENTS = ['h1', 'h2'];
var NvHeadline = function (_a) {
    var children = _a.children, className = _a.className, _b = _a.element, Element = _b === void 0 ? 'h1' : _b, _c = _a.level, level = _c === void 0 ? 'standard' : _c, style = _a.style, props = __rest(_a, ["children", "className", "element", "level", "style"]);
    // Check if element is a valid heading tag
    if (!NV_HEADLINE_ELEMENTS.includes(Element))
        return null;
    // If level is null or invalid, defaults to nv-headline
    var headlineClass = classNames(className, {
        book: 'nv-headline-book',
        small: 'nv-headline-small',
        standard: 'nv-headline',
    }[level] || 'nv-headline');
    return (React.createElement(Element, __assign({}, props, { className: headlineClass, style: style }), children));
};

export { NV_HEADLINE_ELEMENTS, NvHeadline as default };
//# sourceMappingURL=NvHeadline.esm.js.map
